const THEME_CONFIG = {
  ...window.appData,
}

export const getTimings = (time, operator) => {
  const timings = []
  for (let i = 0; i < 24; i++) {
    if (operators[operator](i, time)) {
      timings.push(('0' + (i % 24)).slice(-2) + ':00')
    }
  }
  return timings
}

const operators = {
  '<': (a, b) => a < b,
  '>': (a, b) => a > b,
}

export const getWeekDays = () => ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const getAddressDetails = (components) => {
  const address = {
    state: '',
    city: '',
    pinCode: '',
  }
  components.forEach((object) => {
    if (object.types[0] === 'administrative_area_level_1') {
      address.state = object.long_name
    }
    if (object.types[0] === 'locality') {
      address.city = object.long_name
    }
    if (object.types[0] === 'postal_code') {
      address.pinCode = object.long_name
    }
  })

  return address
}

export const firmTypes = THEME_CONFIG.firmTypes || [
  'Proprietorship',
  'Private Limited Company',
  'Partnership',
  'Limited Liability Partnership',
  'Private Limited',
  'Public Limited',
  'Hindu Undivided Family',
]

export const trimValues = (object) => {
  //trims trailing and leading spaces
  const newObject = {}
  Object.keys(object).forEach((key) => {
    newObject[key] = typeof object[key] === 'string' ? object[key].trim() : object[key]
  })
  return newObject
}

export const getFields = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      arr[data[key].name] = Object.prototype.hasOwnProperty.call(data[key], 'defaultValue') ? data[key].defaultValue : ''
    }
  }
  return arr
}
export const getRegex = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      if (data[key].regex) {
        arr[data[key].name] = data[key].regex
      }
    }
  }
  return arr
}
export const getAllRegex = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].regex) {
          arr[data[key][innerKey].name] = data[key][innerKey].regex
        }
      }
    }
  }
  return arr
}
export const getAllMaxLength = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].maxLength) {
          arr[data[key][innerKey].name] = data[key][innerKey].maxLength
        }
      }
    }
  }
  return arr
}
export const getAllNonMandatoryFields = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].optional) {
          arr[data[key][innerKey].name] = data[key][innerKey].optional
        }
      }
    }
  }
  return arr
}
export const getAllFieldErrors = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].error) {
          arr[data[key][innerKey].name] = data[key][innerKey].error
        }
      }
    }
  }
  return arr
}
export const getFieldLabels = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].label) {
          arr[innerKey] = data[key][innerKey].label
        }
      }
    }
  }
  return arr
}
export const getFieldPlaceholders = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].placeholder) {
          arr[data[key][innerKey].name] = data[key][innerKey].placeholder
        }
      }
    }
  }
  return arr
}
export const getFieldNotes = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].note) {
          arr[data[key][innerKey].name] = data[key][innerKey].note
        }
      }
    }
  }
  return arr
}
export const getFieldExt = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].ext) {
          arr[data[key][innerKey].name] = data[key][innerKey].ext
        }
      }
    }
  }
  return arr
}

export const getFieldOptions = (data) => {
  const arr = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      for (const innerKey in data[key]) {
        if (data[key][innerKey].options) {
          arr[data[key][innerKey].name] = data[key][innerKey].options
        }
      }
    }
  }
  return arr
}
